import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('/yacht-payments', { params: params })
      .then(response => {
        return response.data
      })
  },
  getStats(params) {
    return axios.get('/yacht-payments/stats', { params: params })
      .then(response => {
        return response.data
      })
  },
  downloadXls(params) {
    return axios.get('/yacht-payments/export', { params: params })
      .then(response => {
        return response.data
      })
  }

}
